import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { pipeline } from '@store/DevOpsData';

import * as styles from './Pipeline.module.scss';

const animationVariants = {
	active: {
		scale: 1.2,
	},
};

export const Pipeline: React.FC = () => {
	const [activePipeIndex, setActivePipeIndex] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setActivePipeIndex((oldIndex) => {
				const newIndex = oldIndex === pipeline.length - 1 ? 0 : oldIndex + 1;
				return newIndex;
			});
		}, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<PaddingContainer id="pipeline" className="white-bg">
			<WidthContainer>
				<h2 className="font-size-medium-title">A CD/CI pipeline</h2>
				<div
					className={classNames(
						styles.pipelineContainer,
						'd-md-flex align-items-center justify-content-between mt-4 mt-xl-5'
					)}
				>
					{pipeline.map((pipe, index) => (
						<motion.div
							key={pipe.text}
							className={classNames(
								styles.pipe,
								'd-flex flex-column align-items-center text-center '
							)}
							animate={activePipeIndex === index ? 'active' : 'none'}
						>
							<div className={styles.icon}>
								<pipe.Icon isActive={activePipeIndex === index} />
							</div>

							<div
								className={classNames(
									styles.circleWrapper,
									'd-flex justify-content-center align-items-center'
								)}
							>
								<motion.div
									variants={animationVariants}
									className={styles.circle}
								/>
							</div>
							<p>{pipe.text}</p>
						</motion.div>
					))}
					<div className={styles.arrow} />
				</div>
				<div
					className={classNames(
						styles.typographies,
						'd-flex flex-column flex-md-row mt-5 font-size-sm line-height-26'
					)}
				>
					<div>
						<p className="mb-4">
							A group of instruments that typically consists of the following:
							In addition to centrally storing and protecting the source code,
							VCS Version Control Systems (such as Git, SVN, TFS, etc.)
							facilitate team collaboration and ongoing work merging. These
							tools are not new in the software business and have been in use
							for some time.
						</p>
						<p>
							These tools typically follow soon after the VCS to help automate
							the creation and testing of releases, including CI/CD automation
							servers like Jenkins, Gitlab, etc. As a result, it is frequently
							referred to as Continuous Integration and Continuous Development
							tools since it enables teams to maintain a continuous delivery
							flow.
						</p>
					</div>
					<div>
						<p className="mb-4">
							The following servers and tools may all be put on cloud
							infrastructure (AWS, Azure, and Google Cloud), which makes the
							entire pipeline incredibly flexible, affordable, and simple to
							construct.
						</p>
						<p>
							Tools such as Kubernetes, Terraform, Ansible, and Docker help
							DevOps to manage, scale and deploy the project in a flexible and
							efficient way.
						</p>
					</div>
				</div>
			</WidthContainer>
		</PaddingContainer>
	);
};
